<script setup lang="ts">
import { ref } from 'vue';
import { passwordResetApi } from '@/services/api/passwordReset';

const email = ref('');
const submitting = ref(false);
const sent = ref(false);

async function submit(): Promise<void> {
  if (submitting.value || email.value.length === 0) return;
  submitting.value = true;
  try {
    await passwordResetApi.create(email.value);
    sent.value = true;
  } finally {
    submitting.value = false;
  }
}
</script>

<template>
  <form class="forgot" novalidate @submit.prevent="submit">
    <h1 class="forgot__title">Reset Lost Password</h1>

    <label class="forgot__field" for="forgot-email">
      <input
        id="forgot-email"
        v-model="email"
        type="email"
        name="email"
        placeholder="Email Address"
        required
      />
    </label>

    <button type="submit" :disabled="submitting" class="forgot__submit">
      {{ submitting ? 'Sending…' : 'Email Instructions' }}
    </button>

    <p v-if="sent" class="forgot__sent" role="status">
      An email has been sent to you with reset instructions.
    </p>
  </form>
</template>

<style scoped>
.forgot {
  max-width: 24rem;
  margin: 4rem auto;
  padding: 2rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.forgot__title {
  margin: 0;
  font-size: 1.25rem;
  text-align: center;
}
.forgot__field input {
  width: 100%;
  padding: 0.625rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
}
.forgot__submit {
  padding: 0.625rem 1rem;
  background: #2563eb;
  color: #fff;
  border: 0;
  border-radius: 0.375rem;
  font-weight: 600;
  cursor: pointer;
}
.forgot__submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.forgot__sent {
  margin: 0;
  padding: 0.75rem 1rem;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 0.375rem;
  color: #065f46;
}
</style>
